import { Injectable } from "@angular/core";
import { FormGroup, FormControl, FormArray } from "@angular/forms";
import { RequestPurposeType } from "../../shared/services/request-purpose.service";

@Injectable()
export class ExperimentDesignShowHideService {
    private experimentDesignFormGroup: FormGroup;
    private get treatments(): FormArray { return this.experimentDesignFormGroup.get("treatments") as FormArray };
    private plantsToPots(treatment: FormGroup): FormControl { return treatment.get("plantingInstructions.numberToPots") as FormControl; };
    private plantsToHarvest(treatment: FormGroup): FormControl { return treatment.get("plantingInstructions.numberToHarvest") as FormControl; };
    private pottingInstructions(treatment: FormGroup): FormGroup { return treatment.get("pottingInstructions") as FormGroup; };
    private get pollinationInstructions(): FormGroup { return this.experimentDesignFormGroup.get("pollinationInstructions") as FormGroup; };
    private get harvestInstructions(): FormGroup { return this.experimentDesignFormGroup.get("harvestInstructions") as FormGroup; };
    private get seedsToReturn(): FormControl { return this.experimentDesignFormGroup.get("harvestInstructions.minimumSeedsToReturn") as FormControl; };

    constructor() {
    }

    public updateView(experimentDesignFormGroup: FormGroup, requestPurpose: number) {
        this.experimentDesignFormGroup = experimentDesignFormGroup;

        switch(requestPurpose) {
            case RequestPurposeType.BiomassInFlats: {
                this.biomassInFlats();
                break;
            }
            case RequestPurposeType.BiomassInPots: {
                this.biomassInPots();
                break;
            }
            case RequestPurposeType.PollinationAndImmatureHarvest: {
                this.pollinationAndImmatureHarvest();
                break;
            }
            case RequestPurposeType.Donors: {
                this.donors();
                break;
            }
            default: {
                break;
            }
        }

        this.experimentDesignFormGroup.updateValueAndValidity();
    }

    private biomassInFlats(){
        this.disablePlantsToPots();
        this.disablePlantsToHarvest();
        this.disablePottingInstructions();
        this.disablePollinationInstructions();
        this.disableHarvestInstructions();
    }

    private biomassInPots(){
        this.disablePlantsToHarvest();
        this.disablePollinationInstructions();
        this.disableHarvestInstructions();
    }

    private pollinationAndImmatureHarvest(){
        this.disableSeedsToReturn();
    }

    private donors(){
        this.disablePollinationInstructions();
    }

    private disablePlantsToPots() {
        for(let treatment of this.treatments.controls) {
            this.plantsToPots(treatment as FormGroup).disable();
        };
    }

    private disablePlantsToHarvest() {
        for(let treatment of this.treatments.controls) {
            this.plantsToHarvest(treatment as FormGroup).disable();
        };
    }

    private disablePottingInstructions() {
        for(let treatment of this.treatments.controls) {
            this.pottingInstructions(treatment as FormGroup).disable();
        };
    }

    private disablePollinationInstructions() {
        this.pollinationInstructions.disable();
    }

    private disableHarvestInstructions() {
        this.harvestInstructions.disable();
    }

    private disableSeedsToReturn() {
        this.seedsToReturn.disable();
    }
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/services/experiment-design-show-hide.service.ts